import { render, staticRenderFns } from "./aboutSwiper.vue?vue&type=template&id=f4eef47a&scoped=true&"
import script from "./aboutSwiper.vue?vue&type=script&lang=js&"
export * from "./aboutSwiper.vue?vue&type=script&lang=js&"
import style0 from "./aboutSwiper.vue?vue&type=style&index=0&id=f4eef47a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4eef47a",
  null
  
)

export default component.exports